var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"caption secondary--text"},[_vm._v(" "+_vm._s(_vm.$t('common.time.second_with_count', { count: _vm.remainingSeconds })))])}
var staticRenderFns = []

export { render, staticRenderFns }